import { AclDemoApp } from './acl-demo/AclDemoApp.js';

export default function App() {
  return <AclDemoApp />;
}
